import React, { FC } from 'react';
import type { UniversalPaymentAccountUPAForSendersAndRecipientsProps } from '@/types';
import { Image } from '../image';
import { TextCols } from '../text-cols';

export const UniversalPaymentAccountUPAForSendersAndRecipients: FC<
  UniversalPaymentAccountUPAForSendersAndRecipientsProps
> = ({ content, cover }) => {
  return (
    <section className="universalPaymentAccountUpaForSendersAndRecipients">
      <div className="universalPaymentAccountUpaForSendersAndRecipients--inner">
        <div className="wrapper">
          <TextCols content={content} size="md" maxTitleWidth={853} />
        </div>
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="universalPaymentAccountUpaForSendersAndRecipients--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
      </div>
    </section>
  );
};
